import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  data: {
    pendingSurveys: null,
    hasRequired: null,
    blockedDate: null,
    daysToBlock: null
  },
  blocked: false,
  lastLimitDate: false,
  showModal: true
};

const success = (state = INITIAL_STATE, action: any) => ({
  ...state,
  data: action.data,
  blocked: action.data?.daysToBlock < 1 && action.data?.hasRequired,
  lastLimitDate: action.data?.daysToBlock === 1 && action.data?.hasRequired
});

const hideSurvey = (state = INITIAL_STATE) => ({
  ...state,
  showModal: false
});

export default createReducer(INITIAL_STATE, {
  [Types.GET_SURVEY_VALIDATION_SUCCESS]: success,
  [Types.HIDE_SURVEY]: hideSurvey,
  [Types.GET_SURVEY_VALIDATION_CLEAR]: () => INITIAL_STATE
});
